// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5146":"87d5725ad6a940f2","6783":"025cba76c8381279","9176":"46ab514ad8b4320d"}[chunkId] + ".css";
};